<template>
  <v-container fluid>
    <v-row align="center"
      justify="center"
      class="my-10">
      <h1>單據查詢</h1>
    </v-row>
    <v-card>
      <v-card-title>
        <v-container >
          <v-row>
            <v-col>
              <v-menu
                ref="beginDateMenu"
                :close-on-content-click="false"
                :return-value.sync="beginDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="beginDate"
                    label="開始日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="beginDate"
                  no-title
                  scrollable
                >
                  <v-btn
                    text
                    color="error"
                    @click="$refs.beginDateMenu.save()"
                  >
                    清除
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.beginDateMenu.save(beginDate)"
                  >
                    確認
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-menu
                ref="endDateMenu"
                :close-on-content-click="false"
                :return-value.sync="endDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endDate"
                    label="結束日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  no-title
                  scrollable
                >
                  <v-btn
                    text
                    color="error"
                    @click="$refs.endDateMenu.save()"
                  >
                    清除
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.endDateMenu.save(endDate)"
                  >
                    確認
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-text-field
                v-model="licensePlate"
                label="車牌"
                @input="(val) => (licensePlate = licensePlate.toUpperCase())"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="govTicketId"
                label="單號"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-btn
                class="mt-4"
                type="submit"
                @click="fetchData"
              >
                查詢
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="tickets"
        :items-per-page="10"
        @click:row="openTicketDetailDialog"
        item-key="id"
        class="row-pointer"
        loading-text="Loading... Please wait"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <template>
              <v-container>
                <v-row>
                  <v-col>
                    <v-img
                      height="400px"
                      width="600px"
                      :src="item.sourceData.begin_image.replace('./public', '')"
                    ></v-img>
                  </v-col>
                  <v-col v-if="item.sourceData.end_image">
                    <v-img
                      height="400px"
                      width="600px"
                      :src="item.sourceData.end_image.replace('./public', '')"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      id="printSection"
      v-model="ticketDetailDialog"
      max-width="900px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <span class="text-h5">單據明細</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols=2>
                單號
              </v-col>
              <v-col cols=4> {{ ticketDetailData.govTicketId }}
              </v-col>
              <v-col cols=2>
                費率種類
              </v-col>
              <v-col cols=4> {{ ticketDetailData.govTicketFeeType }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=2>
                車格
              </v-col>
              <v-col cols=4> {{ ticketDetailData.cellId }}
              </v-col>
              <v-col cols=2>
                單據種類
              </v-col>
              <v-col cols=4> {{ ticketDetailData.govTicketType }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=2>
                車牌
              </v-col>
              <v-col cols=4> {{ ticketDetailData.licensePlate }}
              </v-col>
              <v-col cols=2>
                加簽次數
              </v-col>
              <v-col cols=4> {{ ticketDetailData.govTicketUploadedCount }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=2>
                入車時間
              </v-col>
              <v-col cols=4> {{ ticketDetailData.beginTime }}
              </v-col>
              <v-col cols=2>
                優惠次數
              </v-col>
              <v-col cols=4> {{ ticketDetailData.govTicketFeeDiscount }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=2>
                出車時間
              </v-col>
              <v-col cols=4> {{ ticketDetailData.endTime }}
              </v-col>
              <v-col cols=2>
                原始金額
              </v-col>
              <v-col cols=4> {{ ticketDetailData.govTicketFeeOriginal }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=2>
                停留時間
              </v-col>
              <v-col cols=4> {{ ticketDetailData.parkDuration }}
              </v-col>
              <v-col cols=2>
                實際金額
              </v-col>
              <v-col cols=4> {{ ticketDetailData.govTicketFeeActual }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=2>
                繳費狀態
              </v-col>
              <v-col cols=4> {{ ticketDetailData.isPaid }}
              </v-col>
            </v-row>
            <v-row v-for="(beginImage, index) in ticketDetailData.beginImages" v-bind:key="index">
              <v-col cols=2>
                入車照片
              </v-col>
              <v-col cols=10>
                <img width="600px" :src=beginImage.url>
              </v-col>
            </v-row>
            <v-row v-for="(regularData, index) in ticketDetailData.regularDatas" v-bind:key="index">
              <v-col cols=2>
                加簽照片 {{regularData.record_time}}
              </v-col>
              <v-col cols=10>
                <img width="600px" :src=regularData.record_image>
              </v-col>
            </v-row>
            <v-row v-if="ticketDetailData.supportImage">
              <v-col cols=2>
                輔助照片
              </v-col>
              <v-col cols=10>
                <img width="600px" :src=ticketDetailData.supportImage>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=2>
                出車照片
              </v-col>
              <v-col cols=10>
                <img width="600px" :src=ticketDetailData.endImage>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="ticketDetailDialog = false"
          >
            關閉
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="printTicketDetail"
          >
            列印
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      beginDate: '',
      endDate: '',
      ticketDetailDialog: false,
      ticketDetailData: {},
      govTicketId: '',
      licensePlate: '',
      search: '',
      tickets: [],
      headers: [
        {
          text: "單號",
          align: 'start',
          value: 'govTicketId',
          width: '10%',
        },
        {
          text: "車格",
          value: "cellId",
          width: '10%',
        },
        {
          text: "車牌",
          value: "licensePlate",
          width: '10%',
        },
        {
          text: "入車時間",
          value: 'beginTime',
          width: '10%',
        },
        {
          text: "出車時間",
          value: 'endTime',
          width: '10%',
        },
        {
          text: "費率種類",
          value: 'govTicketFeeType',
          width: '10%',
        },
        {
          text: "單據種類",
          value: 'govTicketType',
          width: '10%',
        },
        {
          text: "加簽次數",
          value: 'govTicketUploadedCount',
          width: '10%',
        },
        {
          text: "金額",
          value: 'govTicketFeeActual',
          width: '10%',
        },
        {
          text: "繳費狀況",
          value: "isPaid",
          width: '10%',
        }
      ],
    }
  },
  methods: {
    fetchData() {
      let api = 'api/search?';

      if (this.licensePlate) {
        api += `licensePlate=${this.licensePlate}&`;
      }

      if (this.govTicketId) {
        api += `govTicketId=${this.govTicketId}&`;
      }

      if (this.beginDate) {
        api += `beginDate=${this.beginDate}&`;
      }

      if (this.endDate) {
        api += `endDate=${this.endDate}&`;
      }

      this.axios.get(api).then((resp) => {
        this.tickets = [];
        resp.data.forEach(t => {
          this.tickets.push({
            id: t.id,
            cellId: t.cell_id,
            licensePlate: t.car_id,
            beginTime: t.begin_time,
            beginImages: t.begin_image !== null ? this.generateImageList(t.begin_image) : [],
            endTime: t.end_time,
            endImage: t.end_image !== null ? this.toDisplayImageUrl(t.end_image) : "",
            govTicketId: t.gov_ticket_id,
            govTicketFeeType: t.gov_ticket_fee_type,
            govTicketType: t.gov_ticket_type,
            govTicketUploadedCount: t.gov_ticket_uploaded_count,
            govTicketFeeOriginal: t.gov_ticket_fee_original,
            govTicketFeeActual: t.gov_ticket_fee_actual,
            govTicketFeeDiscount: t.gov_ticket_fee_discount,
            isPaid: t.is_paid ? "Yes" : "No",
            parkDuration: t.park_duration,
            createdAt: t.created_at,
            updatedAt: t.updated_at,
            regularDatas: [],
            sourceData: t,
          })
        });
      })
    },
    toDisplayImageUrl(imagePath) {
      const CUTOFF_BY_HOST = {
        'khh-i001.rpms.pss-group.xyz': '2026-04-29',
        'khh-i002.rpms.pss-group.xyz': '2026-04-29',
        'khh-i003.rpms.pss-group.xyz': '2026-04-17',
        'khh-i004.rpms.pss-group.xyz': '2026-04-17',
        'kaoh.pgs.ichenparking.com.tw': '2026-04-29',
      };

      if (!imagePath) return '';
      const path = `${imagePath}`;

      let webPath;
      if (/^https?:\/\//i.test(path)) {
        webPath = path;
      } else {
        webPath = path
          .replace(/^\.\/public\//, '/')
          .replace(/^\/?public\//, '/');
      }

      if (!webPath) return '';

      const host = window.location.hostname;
      const cutoff = CUTOFF_BY_HOST[host];

      if (!cutoff) return webPath;

      const dateMatch = webPath.match(/\/TCL217\/(\d{4}-\d{2}-\d{2})\//);
      const imageDate = dateMatch && dateMatch[1];

      if (!imageDate || imageDate >= cutoff) return webPath;

      const url = new URL(webPath, window.location.origin);

      return `https://old.${host}:9193${url.pathname}${url.search}${url.hash}`;
    },
    generateImageList(mainImagePath) {
      const webPath = mainImagePath.replace(/^\.\/public\//, '/');
      const match = webPath.match(/_(\d+)_(\d+)\.jpg$/);
      if (!match) return [{
        url: this.toDisplayImageUrl(webPath),
        isMain: true,
      }];

      const currentIndex = parseInt(match[1], 10);
      const total = parseInt(match[2], 10);
      const baseName = webPath.replace(/_\d+_\d+\.jpg$/, '');

      return Array.from({ length: total }, (_, i) => ({
        url: this.toDisplayImageUrl(`${baseName}_${i + 1}_${total}.jpg`),
        isMain: i + 1 === currentIndex
      }));
    },
    openTicketDetailDialog(value) {
      value.regularDatas = [];
      this.axios.get(`api/tcl217/regular?begin=${value.beginTime}&end=${value.endTime}&id=${value.cellId}`).then((resp) => {
        resp.data.forEach(r => {
          r.record_image = this.toDisplayImageUrl(r.record_image);
          value.regularDatas.push(r)
        })
        this.ticketDetailData = value;
        this.ticketDetailDialog = true;
      })
    },
    printTicketDetail() {
      window.print();
    }
  }
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.container {
  font-size: large;
}

</style>

<style>
  @media print{
    body * {
      visibility:hidden;
    }
    .v-dialog, .v-dialog * {
      visibility:visible;
      color: black;
    }
    .v-card__actions * {
      visibility: hidden;
    }
    .v-dialog__content {
      position: unset;
    }
    .v-dialog {
      position:absolute;
      left:0;
      top:0;
      overflow: visible;
    }
    .row {
      font-size: x-large;
    }
    img {
      height: 280px;
      width: auto;
    }
  }
</style>
